module.exports = __webpack_public_path__ + "img/SAP.4f83ea40.png";